<template>
  <div>
    <vue-simple-markdown
      v-if="content"
      class="md-body"
      :class="classes"
      :source="content"
    ></vue-simple-markdown>
  </div>
</template>

<script>
export default {
  props: {
    content: {
      type: String,
      default: () => ''
    },
    type: {
      type: String,
      default: () => ''
    }
  },
  computed: {
    classes() {
      let cls = [this.type];
      return cls;
    }
  }
};
</script>

<style lang="scss">
.md-body {
  margin-bottom: 24px;
  white-space: pre-wrap;

  a {
    color: inherit;
    text-decoration: underline;
  }

  strong {
    font-weight: 600;
  }

  h3,
  h2,
  h1 {
    font-style: normal;
    font-weight: 700;
    margin: 0;
    text-transform: uppercase;
  }

  &.story-part {
    font-size: 16px;
    font-weight: 500;
    line-height: 140%;

    margin: 10px 0;
  }
}
</style>
